import { Dashboard } from '../dashboard';
import { useDashboardTasks } from './use-dashboard-tasks';

export const DashboardTasks = () => {
  const { chartsData } = useDashboardTasks();

  return <Dashboard chartsData={chartsData} />;
};
